import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import "./AdminLayout.css";

export default function AdminLayout() {
  return (
    <div className="admin">
      <Sidebar />

      <div className="admin__main">
        <Topbar />
        <div className="admin__content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
